import { Outlet, Navigate } from "react-router-dom"
import { useSelector } from "react-redux";
import { Cookie } from "../app/base/utils";

const SubOwnerValidation = () => {
  //const token: any = Cookie.get();
  const _login: any = useSelector((state: any) => state.login.login);
  const token: any = Cookie.get();

  return (
    (_login.role_id == 1 || _login.role_id == 2) ? <Outlet /> : <Navigate to="/unauthorized" />
  )
}

export default SubOwnerValidation;